import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";

function General() {
  const user = useSelector((state) => state.user.user);

  if (!user)
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "5%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  return (
    <div className="col-12 col-md-9">
      <div className="card card-bleed shadow-light-lg mb-6">
        <div className="card-header">
          <h4 className="mb-0">Basic Information</h4>
        </div>
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="name">
                    Name
                  </label>
                  <input
                    className="form-control"
                    id="name"
                    type="text"
                    defaultValue={`${user.first_name} ${user.last_name}`}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="phonenumber">
                    Phone number
                  </label>
                  <input
                    className="form-control"
                    id="phonenumber"
                    type="text"
                    defaultValue={user.phone_number}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="address">
                    Address
                  </label>
                  <input
                    className="form-control"
                    id="address"
                    type="text"
                    defaultValue={user.address}
                    disabled
                  />
                </div>
              </div>

              {/* <div className="col-12 col-md-auto">
                <button className="btn w-100 btn-primary" type="submit">
                  Save changes
                </button>
              </div> */}
            </div>
          </form>
        </div>
      </div>

      <div className="card card-bleed shadow-light-lg mb-6">
        <div className="card-header">
          <h4 className="mb-0">Your avatar</h4>
        </div>
        <div className="card-body">
          <div className="list-group list-group-flush">
            <div className="list-group-item">
              <div className="row align-items-center">
                <div className="col-auto">
                  <div className="avatar avatar-xl">
                    <img
                      className="avatar-img rounded-circle"
                      src={user.photo_url}
                      alt="User Avatar"
                    />
                  </div>
                </div>
                <div className="col ms-n5">
                  <p className="mb-0">Your avatar</p>

                  {/* <small className="text-gray-700">
                    PNG or JPG no larger than 1000px
                  </small> */}
                </div>
                {/* <div className="col-12 col-md-auto">
                  <button className="btn btn-xs w-100 btn-primary mt-5 mt-md-0">
                    Upload
                  </button>
                </div> */}
              </div>
            </div>
            {/* <div className="list-group-item">
              <p className="mb-0">Profile cover</p>

              <p className="small text-gray-700">
                PNG or JPG at 16:9 ratio no larger than 2MB
              </p>

              <div
                className="dropzone dropzone-single"
                data-dropzone='{"url": "https://", "maxFiles": 1, "acceptedFiles": "image/*"}'
              >
                <div className="fallback">
                  <div className="custom-file">
                    <input
                      className="custom-file-input"
                      id="projectCoverUploads"
                      type="file"
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="projectCoverUploads"
                    >
                      Choose file
                    </label>
                  </div>
                </div>

                <div className="dz-preview dz-preview-single">
                  <div className="dz-preview-cover">
                    <img
                      className="dz-preview-img"
                      data-dz-thumbnail
                      src="data:image/svg+xml,%3csvg3c/svg%3e"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default General;
